class ContactPage {
  constructor() {
    this.$page = $('.contactPage');
    if (!this.$page.length) return;

    // フォームのエンドポイントマッピング
    this.formEndpoints = {
      'inquiryForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdOybhh0TkGpkpf4SQ3RewQZJ9_U0pF06l7Uy9WCqIy7eWYvg/formResponse',
      'purchaseForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSc1ddrWi78ihW6vM6spqTYEzEoRAmimrE3ELSx6a2Oz-2iPzg/formResponse',
      // 'purchaseForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScEEJdj-0RwM5IlZca7hw6BJSKVL4UNd_pF3KhqlHfXowK3iw/formResponse',
      'cancelForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSd9xws95y0HMipVOiQllIUGMr7wKj9-LinCi8SRxCPjgv0pbQ/formResponse',
      'repairForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeD0cfnPpp6rB6SgL6BNdpsYBf1GQFQxY2amKiUVlgeCilujQ/formResponse',
      'accountForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdbr1BNgD0EokojSwAYhQGMJGzMmeaoOBwOeQaqJ0nVbZFFiA/formResponse',
      // 'catlitterSkipForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeFvubdvB1xCos-7U3CzHAYQABYp0XKBhA9SU2yd6JE5uiSsw/formResponse',
      'catlitterSkipForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdJ5_sDXKBC2Yx4xyoG4zPkaDeYlMpOFJHjh3DQOyjxNg26CQ/formResponse',
      'friendIntroductionForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSehDl47nhIGaG7dxT-pJkK_bb1AQZlt23tSmLPt7AFx4T7Abw/formResponse',
      'friendIntroductionCodeForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLScxfrSzVpDUOo3V7FZBkWBYs3ealkTLVc2kZ0EIRk5AhEC3QA/formResponse'
    };

    // フォーム要素の特定
    this.$form = this.$page.find('form');
    this.formId = this.$form.attr('id');

    // フォームの各状態のコンテンツ要素
    this.$inputContent = this.$page.find('[data-state="input"]');
    this.$confirmContent = this.$page.find('[data-state="confirm"]');
    this.$completeContent = this.$page.find('[data-state="complete"]');

    // ボタン要素
    this.$confirmButton = this.$inputContent.find('.--button .c-button');
    this.$editButton = this.$confirmContent.find('.--button .c-button').eq(0);
    this.$submitButton = this.$confirmContent.find('.--button .c-button').eq(1);

    // 表示用とAPI送信用の別々のデータオブジェクトを用意
    this.displayData = {};
    this.formData = {};

    // メール存在チェック状態
    this.emailExists = null;
    this.isCheckingEmail = false;

    // capture handler 用の参照（後で remove できるように）
    this._miruto30CaptureHandler = null;

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupAttachmentWatcher();
    this.detectOrderSource();
    this.setupProductConditionalVisibility();
    this.setupEmailExistCheck();

    // ★追加：30ヶ月モーダル（強制拾い版）
    this.setupThirtyMonthsModal();
  }

  /**
   * 購入元の特定処理
   */
  detectOrderSource() {
    // 注文番号・購入元inputのjQuery取得
    const $orderInput = $('#contact_order');
    const $storeInput = $('#contact_store');

    $orderInput.on('input', function() {
      const val = $(this).val().trim();
      let storeName = '';

      if (/^OC-\d{12}-[a-zA-Z0-9]{3}-\d{6}$/.test(val)) {
        storeName = 'サブスクストア';
      } else if (/^\d{3}-\d{7}-\d{7}$/.test(val)) {
        storeName = 'Amazon';
      } else if (/^\d{4,8}$/.test(val)) {
        storeName = 'Shopify';
      } else {
        storeName = 'その他';
      }
      $storeInput.val(storeName);
    });
  }

  // 解約製品の選択肢に応じて該当項目を出し分ける
  setupProductConditionalVisibility() {
    const $productSelect = $('#contact_product');

    if (!$productSelect.length) return;

    const toggleFields = (isCatLitter) => {
      const fieldIds = [
        'entry.966699525',     // トラッキング番号
        'entry.1736121538',    // 水洗い
        'entry.379981321',     // 梱包
        'entry.351754600'      // 同梱物
      ];

      fieldIds.forEach(id => {
        const $field = $(`[data-fields="${id}"]`);
        if (isCatLitter) {
          $field.hide();
        } else {
          $field.show();
        }
      });
    };

    // 初期状態でチェック
    const initialValue = $productSelect.val();
    toggleFields(initialValue.includes('ねこ砂'));

    // 値が変更されたらチェック
    $productSelect.on('change', function () {
      const value = $(this).val();
      toggleFields(value.includes('ねこ砂'));
    });
  }

  /**
   * contact_attachment があるページだけ
   * ファイル名抽出の interval を登録
   */
  setupAttachmentWatcher() {
    const input    = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');
    if (!input || !errorMsg) return;

    setInterval(() => {
      const raw     = input.value;
      const matches = raw.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
      const unique  = [...new Set(matches)];
      input.value   = unique.join(' ');
      errorMsg.style.display = unique.length > 0 ? 'none' : 'block';
    }, 500);
  }

  bindEvents() {
    // フォームのデフォルトの送信を防ぐ
    this.$form.on('submit', (e) => e.preventDefault());

    // 確認ボタンクリック時の処理
    this.$confirmButton.on('click', () => this.handleConfirm());

    // 編集に戻るボタンクリック時の処理
    this.$editButton.on('click', () => this.handleEdit());

    // 送信ボタンクリック時の処理
    this.$submitButton.on('click', () => this.handleSubmit());

    // チェックボックスの特別処理
    this.$form.find('input[type="checkbox"]').on('change', function () {
      const $field = $(this).closest('.contactForm__item');
      const errorMsg = $field.find('.errorMsg');
      if (this.checked) {
        errorMsg.css('display', 'none');
      }
    });
  }

  /**
   * ★追加：30ヶ月案内モーダル（Coco/Mimi ねこ砂定期便）
   * - モーダルDOMが無ければ自動生成
   * - イベント委譲で後からDOMがあっても拾う
   * - stopPropagation 対策で capture でも拾う
   */
  setupThirtyMonthsModal() {
    const TARGET_FORS = [
      'purchase_coco_renatl_cat-litter',
      'purchase_mimi_renatl_cat-litter',
    ];

    const labelSelector = TARGET_FORS.map(v => `label[for="${v}"]`).join(',');
    const inputSelector = TARGET_FORS.map(v => `#${v}`).join(',');

    // ① モーダルDOMが無ければ自動生成（入れ忘れでも動く）
    const ensureModalDom = () => {
      let $modal = $('#miruto_30months_modal');
      if ($modal.length) return $modal;

      // CSSも無いケースに備えて最低限注入（idでガード）
      if (!document.getElementById('miruto_30months_modal_style')) {
        const style = document.createElement('style');
        style.id = 'miruto_30months_modal_style';
        style.textContent = `
          .mirutoModal{position:fixed;inset:0;z-index:9999;display:none}
          .mirutoModal.is-open{display:block}
          .mirutoModal__overlay{position:absolute;inset:0;background:rgba(0,0,0,.45)}
          .mirutoModal__panel{position:absolute;left:50%;top:50%;width:min(92vw,520px);transform:translate(-50%,-50%);
            background:#fff;border-radius:16px;padding:22px 18px 18px;box-shadow:0 12px 40px rgba(0,0,0,.18)}
          .mirutoModal__close{position:absolute;right:10px;top:10px;width:40px;height:40px;border:none;background:transparent;
            font-size:22px;line-height:40px;cursor:pointer}
          .mirutoModal__text{margin:6px 0 16px;font-size:15px;line-height:1.7;color:#222}
          .mirutoModal__cta{display:inline-flex;align-items:center;justify-content:center;width:100%;padding:12px 14px;border-radius:12px;
            text-decoration:none;font-weight:700;background:#111;color:#fff}
          body.is-modal-open{overflow:hidden}
        `;
        document.head.appendChild(style);
      }

      $('body').append(`
        <div class="mirutoModal" id="miruto_30months_modal" aria-hidden="true" role="dialog" aria-modal="true">
          <div class="mirutoModal__overlay" data-modal-close></div>
          <div class="mirutoModal__panel" role="document">
            <button class="mirutoModal__close" type="button" aria-label="閉じる" data-modal-close><span aria-hidden="true">×</span></button>
            <p class="mirutoModal__text">こちらのプランでは30ヶ月以上継続の場合,無償で新品と交換させていただきます</p>
            <a class="mirutoModal__cta" href="https://www.miruto.shop/pages/contact/?status=repair">製品の不具合の問い合わせはこちら</a>
          </div>
        </div>
      `);

      return $('#miruto_30months_modal');
    };

    const $modal = ensureModalDom();

    const openModal = () => {
      $modal.addClass('is-open').attr('aria-hidden', 'false');
      $('body').addClass('is-modal-open');
    };

    const closeModal = () => {
      $modal.removeClass('is-open').attr('aria-hidden', 'true');
      $('body').removeClass('is-modal-open');
    };

    // ② 閉じる（背景/×）
    $(document)
      .off('click.miruto30close')
      .on('click.miruto30close', '#miruto_30months_modal [data-modal-close]', (e) => {
        e.preventDefault();
        closeModal();
      });

    // ③ Escで閉じる
    $(document)
      .off('keydown.miruto30esc')
      .on('keydown.miruto30esc', (e) => {
        if (e.key === 'Escape' && $modal.hasClass('is-open')) closeModal();
      });

    // ④ 開く：イベント委譲（要素が後から出てもOK）
    $(document)
      .off('click.miruto30open')
      .on('click.miruto30open', labelSelector, () => {
        // radio の選択は止めない（preventDefaultしない）
        openModal();
      });

    $(document)
      .off('click.miruto30open2 change.miruto30open2')
      .on('click.miruto30open2 change.miruto30open2', inputSelector, () => {
        openModal();
      });

    // ⑤ stopPropagation 対策：capture で強制的に拾う
    const nativeSelector = `${labelSelector}, ${inputSelector}`;
    if (this._miruto30CaptureHandler) {
      document.removeEventListener('click', this._miruto30CaptureHandler, true);
    }
    this._miruto30CaptureHandler = (e) => {
      const hit = e.target && e.target.closest && e.target.closest(nativeSelector);
      if (hit) openModal();
    };
    document.addEventListener('click', this._miruto30CaptureHandler, true);
  }

  // 必須項目のバリデーション
  validateRequiredFields() {
    let isValid = true;
    const requiredFields = this.$form.find('.--require');

    requiredFields.each((_, field) => {
      const $field = $(field);
      const input = $field.find('input, textarea, select');
      const errorMsg = $field.find('.errorMsg');
      const value = input.val()?.trim(); // 空チェック用
      const inputType = input.attr('type') || input.prop('tagName').toLowerCase(); // inputタイプまたはタグを取得
      const nameAttr = input.attr('name');

      // 非表示のフィールドはバリデーション対象外にする
      if (!$field.is(':visible')) return;

      if (nameAttr === 'entry.1776017831') return;

      if (inputType === 'checkbox') {
        // チェックボックスのバリデーション
        if (!input.prop('checked')) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'email') {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const inputId = input.attr('id');

        // 確認用メール：形式チェック＋未入力（必須）だけ。存在チェック状態は見ない
        if (inputId === 'contact_email_confirm') {
          if (!value) {
            errorMsg.text('※メールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else if (!emailPattern.test(value)) {
            errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else {
            errorMsg.css('display', 'none');
          }
          return;
        }

        // 送信用メール：従来どおり（存在チェック込み）
        if (!emailPattern.test(value)) {
          errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
          isValid = false;
        } else if (this.isCheckingEmail) {
          errorMsg.text('メールアドレスを確認中です。少しお待ちください。').css('display', 'block');
          isValid = false;
        } else if (this.emailExists === false) {
          errorMsg.text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }

        return;

      } else if (inputType === 'tel') {
        const errorMsgText = (msg) => errorMsg.text(msg).css('display', 'block');

        const numericPattern = /^[0-9]+$/;
        const phonePattern = /^0\d{9,10}$/;

        if (!value) {
          errorMsgText('電話番号を入力してください');
          isValid = false;
        } else if (!numericPattern.test(value)) {
          errorMsgText('電話番号には数字のみを入力してください（ハイフンは不要です）');
          isValid = false;
        } else if (!phonePattern.test(value)) {
          errorMsgText('有効な電話番号を入力してください');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'radio') {
        // ラジオボタンのバリデーション
        if (input.filter(":checked").length == 0) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'select') {
        // セレクトボックスのバリデーション
        if (!value || value === '選択してください') {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else {
        // 必須項目のバリデーション (共通)
        if (!value || value === '選択してください') {
          // 注文番号だけ文言を変えたい場合
          if (nameAttr === 'entry.1697080420') {
            errorMsg.text('※注文番号を入力してください').css('display', 'block');
          } else {
            errorMsg.text('この項目は必須です').css('display', 'block');
          }
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      }
    });

    const input = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');

    if (input && errorMsg) {
      setInterval(() => {
        const rawValue = input.value;
        const matches = rawValue.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
        const uniqueFilenames = [...new Set(matches)];
        input.value = uniqueFilenames.join(' ');

        if (uniqueFilenames.length > 0) {
          errorMsg.style.display = 'none';
        } else {
          errorMsg.style.display = 'block';
        }
      }, 500);
    }

    const attachmentInput = document.getElementById('contact_attachment');
    const attachmentErrorMsg = attachmentInput?.parentElement.querySelector('.errorMsg');

    if (attachmentInput && attachmentErrorMsg) {
      const fileNames = attachmentInput.value.trim();
      if (!fileNames) {
        attachmentErrorMsg.style.display = 'block';
        isValid = false;
      } else {
        attachmentErrorMsg.style.display = 'none';
      }
    }

    // ============================
    // 追加：送信用メールと確認用メールの一致チェック
    // ============================
    const $mainEmail = this.$form.find('#contact_email');
    const $confirmEmail = this.$form.find('#contact_email_confirm');

    if ($mainEmail.length && $confirmEmail.length && $confirmEmail.closest('.contactForm__item').is(':visible')) {
      const mainVal = ($mainEmail.val() || '').trim();
      const confirmVal = ($confirmEmail.val() || '').trim();

      const $confirmField = $confirmEmail.closest('.contactForm__item');
      const $confirmError = $confirmField.find('.errorMsg');

      // main は required 側で空チェックされる前提だが、念のため
      if (mainVal && confirmVal && mainVal !== confirmVal) {
        $confirmError
          .text('※メールアドレスが一致しません。再入力してください')
          .css('display', 'block');
        isValid = false;
      }
    }

    return isValid;
  }

  // 入力されたEmailアドレスの存在チェック
  setupEmailExistCheck() {
    // 買い切り申請フォームで動作
    if (this.formId !== 'purchaseForm') return;

    const $emailInput = this.$form.find('#contact_email');
    if (!$emailInput.length) return;

    const $field = $emailInput.closest('.contactForm__item');
    const $errorMsg = $field.find('.errorMsg');

    // ステータスメッセージ用要素を追加
    let $statusMsg = $field.find('.emailCheckMsg');
    if (!$statusMsg.length) {
      $statusMsg = $('<p class="emailCheckMsg" style="margin-top:4px;font-size:12px;"></p>');
      $statusMsg.insertAfter($errorMsg);
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let timer = null;
    const endpoint = 'https://miruto-check-email-address.vc-dev.workers.dev/apps/customer/email-check';

    const execCheck = (email) => {
      if (!emailPattern.test(email)) {
        this.emailExists = null;
        $statusMsg.text('').hide();
        return;
      }

      this.isCheckingEmail = true;
      this.emailExists = null;

      $statusMsg
        .text('メールアドレスを確認しています…')
        .css('color', '#6a676b')
        .show();

      fetch(`${endpoint}?email=${encodeURIComponent(email)}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.exists === true) {
            this.emailExists = true;
            $statusMsg
              .text('このメールアドレスはレンタル時に登録されたメールアドレスです。')
              .css('color', '#008000')
              .show();
          } else if (data && data.exists === false) {
            this.emailExists = false;
            $statusMsg
              .text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。')
              .css('color', '#ef857d')
              .show();
          } else {
            this.emailExists = null;
            $statusMsg
              .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
              .css('color', '#ef857d')
              .show();
          }
        })
        .catch(() => {
          this.emailExists = null;
          $statusMsg
            .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
            .css('color', '#ef857d')
            .show();
        })
        .finally(() => {
          this.isCheckingEmail = false;
        });
    };

    // 入力が止まって 500ms 後 or blur でチェック
    $emailInput.on('input', () => {
      const email = $emailInput.val().trim();

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => execCheck(email), 500);
    });

    $emailInput.on('blur', () => {
      const email = $emailInput.val().trim();
      if (!email) return;
      execCheck(email);
    });
  }

  /**
   * 名前・電話・メール・注文番号が Shopify 注文と一致するかを Workers でチェック
   * - true  : OK（確認画面へ進める）
   * - false : NG（注文番号欄にエラー表示）
   */
  async validateOrderAndCustomer() {
    // 買い切り申請フォーム以外では何もしない
    if (this.formId !== 'purchaseForm') return true;

    const $nameInput  = this.$form.find('#contact_name');
    const $telInput   = this.$form.find('input[type="tel"]');
    const $emailInput = this.$form.find('#contact_email');
    const $orderInput = this.$form.find('input[name="entry.1697080420"]');

    if (!$orderInput.length) return true; // 念のため

    const name  = $nameInput.val()?.trim()  || '';
    const phone = $telInput.val()?.trim()   || '';
    const email = $emailInput.val()?.trim() || '';
    const order = $orderInput.val()?.trim() || '';

    const $orderField    = $orderInput.closest('.contactForm__item');
    const $orderErrorMsg = $orderField.find('.errorMsg');

    // 「不明」または空欄はここではチェックしない（必須チェック側に任せる）
    if (!order || order === '不明') {
      // 念のためエラーメッセージを消しておく
      // （必須エラーは validateRequiredFields() が出す）
      if (order && order === '不明') {
        // 不明でも OK というメッセージを出したければここで
        // $orderErrorMsg.text('注文番号が不明の場合は「不明」で送信いただけます。').css('display', 'block');
      }
      return true;
    }

    // ▼ ここから追加：数字のみの場合は「4桁以上」でないとエラーにする
    // 全角数字は半角に、ハイフンなどは除外して長さを確認
    const numericOnly = order
      .replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFF10 + 0x30)) // 全角 → 半角
      .replace(/\D/g, ''); // 数字以外を除去

    // 「数字だけで構成されている & 4桁未満」の場合は形式エラー
    if (/^[0-9０-９]+$/.test(order) && numericOnly.length > 0 && numericOnly.length < 4) {
      $orderErrorMsg
        .text('注文番号は4桁以上の数字で入力してください。（例：1001）')
        .css('display', 'block');
      return false;
    }

    // Workers のエンドポイント
    const endpoint =
      'https://miruto-check-email-address.vc-dev.workers.dev/apps/order/validate';

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_number: order,
          name,
          phone,
          email,
        }),
      });

      const data = await res.json().catch(() => null);

      if (!data || data.valid !== true) {
        const reason = data && data.reason;

        if (reason === 'order_not_found') {
          $orderErrorMsg
            .text('この注文番号のご注文が見つかりません。注文確認メールまたはマイページから注文番号をご確認ください。')
            .css('display', 'block');
        } else if (reason === 'buyout_completed') {
          $orderErrorMsg
            .text('このご注文はすでに買い切り精算が完了しています。本フォームからの再申請は不要です。')
            .css('display', 'block');
        } else {
          $orderErrorMsg
            .text('入力されたお名前・電話番号・メールアドレスと注文番号の組み合わせが確認できませんでした。ご注文情報をご確認のうえ、再度ご入力ください。')
            .css('display', 'block');
        }

        return false;
      }

      // OK の場合はエラーを消す
      $orderErrorMsg.css('display', 'none');
      return true;
    } catch (e) {
      console.error('order validate error', e);
      // 通信エラー時は、とりあえず通す or 止めるかは運用ポリシー次第
      // 今回は「念のため止める」ほうが安全そう
      $orderErrorMsg
        .text('注文番号の確認に失敗しました。時間をおいて再度お試しください。')
        .css('display', 'block');
      return false;
    }
  }

  // フォームデータの収集
  collectFormData() {
    const formData = new FormData(this.$form[0]);
    this.displayData = {};
    this.formData = {};

    for (const [key, value] of formData.entries()) {
      // 確認用メールは送信しない（Googleフォーム項目なし）
      if (key === 'email_confirm') {
        continue;
      }

      if (value instanceof File) continue;

      // 日付フィールドの処理
      if (key.includes('entry.') && value.includes('-')) {
        const isPotentialDate = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (isPotentialDate) {
          try {
            const date = new Date(value);
            // 元のキーから年月日のキーを生成
            const baseKey = key.split('_')[0];

            // Google Forms送信用データ
            this.formData[`${baseKey}_year`] = date.getFullYear().toString();
            this.formData[`${baseKey}_month`] = (date.getMonth() + 1).toString();
            this.formData[`${baseKey}_day`] = date.getDate().toString();

            // 確認画面表示用データ
            this.displayData[key] = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
          } catch (e) {
            console.error('Date parsing error:', e);
            this.displayData[key] = value;
          }
        } else {
          // 日付形式でない場合（住所など）
          this.displayData[key] = value;
          this.formData[key] = value;
        }
      } else if (key.includes('entry.') && this.$form.find(`[name="${key}"]`).attr('type') === 'checkbox') {
        // チェックボックスの処理
        const $checkbox = this.$form.find(`[name="${key}"]`);
        if ($checkbox.prop('checked')) {
          const caption = $checkbox.next('label').text();
          const checkboxValue = $checkbox.val(); // value属性の値を取得
          this.displayData[key] = caption;      // 表示用にはキャプションを使用
          this.formData[key] = checkboxValue;   // 送信用にはvalue属性の値を使用
        }
      } else {
        // その他のフィールド
        this.formData[key] = value;
        this.displayData[key] = value;
      }
    }

    // デバッグ用：グローバルに公開
    window.contactData = {
      displayData: this.displayData,
      formData: this.formData
    };

    // デバッグ用：コンソールに出力
    console.log('Display Data:', this.displayData);
    console.log('Form Data to be sent:', this.formData);
  }

  // 確認画面にデータを表示
  displayConfirmData() {
    const confirmFields = this.$confirmContent.find('.contactForm__item');

    confirmFields.each((_, field) => {
      const $field = $(field);
      const fieldName = $field.data('fields');
      const confirmContent = $field.find('.confirm_content');

      if (fieldName && this.displayData[fieldName]) {
        confirmContent.text(this.displayData[fieldName]);
      }
    });
  }

  // Google Formsへのデータ送信
  async submitToGoogleForms() {
    const formUrl = this.formEndpoints[this.formId];
    if (!formUrl) {
      console.error('Form endpoint not found');
      return false;
    }

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(this.formData),
      });

      return true;
    } catch (error) {
      console.error('Form submission error:', error);
      return false;
    }
  }

  // 確認ボタン処理
  async handleConfirm() {
    const $buttonErrorMsg = this.$inputContent.find('.--button .errorMsg');

    // 1. 必須チェック
    if (!this.validateRequiredFields()) {
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 2. 注文番号＋顧客情報の照合（買い切りフォームのみ実行）
    const isOrderValid = await this.validateOrderAndCustomer();
    if (!isOrderValid) {
      // 注文番号欄にエラーが出ているのでボタン下にもエラーを出しておく
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 3. すべて OK → 確認画面へ
    $buttonErrorMsg.hide();

    this.collectFormData();
    this.displayConfirmData();

    this.$inputContent.css('display', 'none');
    this.$confirmContent.css('display', 'block');

    console.log('=== Confirmation Data ===');
    console.log('Data to be displayed:', window.contactData.displayData);
    console.log('Data to be sent:', window.contactData.formData);

    window.scrollTo(0, 0);
  }


  // 編集に戻る処理
  handleEdit() {
    this.$confirmContent.css('display', 'none');
    this.$inputContent.css('display', 'block');

    // ページトップにスクロール
    window.scrollTo(0, 0);
  }

  // 送信処理
  async handleSubmit() {
    const success = await this.submitToGoogleForms();

    if (success) {
      this.$confirmContent.css('display', 'none');
      this.$completeContent.css('display', 'block');

      // ページトップにスクロール
      window.scrollTo(0, 0);

      // フォームをリセット
      this.$form[0].reset();
    } else {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  }
}

// インスタンス化
document.addEventListener('DOMContentLoaded', () => {
  new ContactPage();
});